<template>
  <ValidationProvider v-slot="{ errors }" :name="name" :rules="rules">
    <div class="input_wrapper">
      <label :for="name">{{ label }}</label>

      <vue-editor
        dir="ltr"
        :editor-options="toolbarOptions"
        ref="editor"
        @text-change="updateValue"
        v-model="content"
      ></vue-editor>
      <span v-if="errors[0]" class="error--text d-inline-block">
        {{ errors[0] }}
      </span>
    </div>
  </ValidationProvider>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  props: {
    name: {
      required: true,
    },
    label: {
      required: false,
    },
    rules: {
      required: false,
      default: "",
    },
    type: {
      required: false,
      default: "text",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
      default: " ",
    },
  },
  data() {
    let toolbarOptions = {
      modules: {
        toolbar: {
          container: [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [
              {
                color: [
                  "#29398c",
                  "#edd70c",
                  "#ecb737",
                  "#f2f4fb",
                  "#fff",
                  "#141324",
                  "#737195",
                  "#000",
                  "#1fb6ff",
                  "#7e5bef",
                  "#ff49db",
                  "#ff7849",
                  "#13ce66",
                ],
              },
              { background: [] },
            ],
            ["link", "image", "video"],
            ["clean"],
            ["showHtml"],
          ],
          handlers: {
            showHtml: () => {
              if (this.txtArea.style.display === "") {
                const html = this.txtArea.value;
                if (html === "<p><br/></p>") {
                  this.html = null;
                } else {
                  this.html = html.replace(new RegExp("<p><br/>", "g"), "<p>");
                }
                this.quill.pasteHTML(html);
              }
              this.txtArea.style.display =
                this.txtArea.style.display === "none" ? "" : "none";
            },
          },
        },
      },
    };
    return {
      toolbarOptions,
      content: "",
      rawContent: "",
    };
  },
  components: {
    VueEditor,
  },
  mounted() {
    this.quill = this.$refs.editor.quill;
    this.txtArea = document.createElement("textarea");
    this.txtArea.style.cssText =
      "width: 100%;margin: 0px;background: rgb(29, 29, 29);box-sizing: border-box;color: rgb(204, 204, 204);font-size: 15px;outline: none;padding: 20px;line-height: 24px;font-family: Consolas, Menlo, Monaco, &quot;Courier New&quot;, monospace;position: absolute;top: 0;bottom: 0;border: none;display:none;resize: none;";

    const htmlEditor = this.quill.addContainer("ql-custom");
    htmlEditor.appendChild(this.txtArea);

    this.quill.on("text-change", () => {
      var html = this.quill.getHTML();
      this.txtArea.value = html;
    });
    this.content = this.value;
  },
  watch: {
    content() {
      this.rawContent = this.content;
    },
    rawContent() {
      this.content = this.rawContent;
    },
  },
  methods: {
    updateValue() {
      this.$emit("input", this.$refs.editor.quill.getHTML());
    },
    async uploadImage(file, Editor, cursorLocation, resetUploader) {
      const fd = new window.FormData();
      fd.append("file", file);
      fd.append("upload_preset", "vxjellmt");
      fd.append("folder", "outorah");
      const { data } = await axios.post(
        "https://api.cloudinary.com/v1_1/ouinternal/image/upload",
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      let url = `https://res.cloudinary.com/ouinternal/image/upload/${data.public_id}`;
      Editor.insertEmbed(cursorLocation, "image", url);
      resetUploader();
    },
  },
};
</script>

<style lang="scss">
.quillWrapper {
  .ql-formats {
    margin: 0 !important;
  }
  .ql-picker-options {
    height: 130px;
    overflow-y: auto;
  }
}
span.ql-formats:first-child > .ql-picker,
span.ql-header.ql-picker {
  border: 1px solid #ddd;
  display: flex;
  height: 100%;
  padding: 2px;
  box-shadow: inset 0 1px 1px -1px rgba(0, 0, 0, 0.2);
  background: white;
}
.ql-toolbar.ql-snow {
  @apply tw-flex tw-items-center tw-flex-wrap  tw-gap-1;
}

.ql-snow .ql-fill,
.ql-snow .ql-stroke.ql-fill {
  fill: #555d66 !important;
}
.ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.3) !important;
  font-style: normal !important;
}
.ql-editor {
  @apply tw-font-poppins;
}

.ql-formats button:hover,
.ql-formats .ql-picker:hover {
  background: #abd4ff73 !important;
}

button {
  @apply tw-w-fit;
  &.ql-showHtml {
    @apply tw-text-text tw-flex;

    &::after {
      content: "</>";
      //   @apply tw-text-text tw-flex;
    }
  }
}
</style>
